import eight from "../assets/svg/projects/eight.svg";
import five from "../assets/svg/projects/five.svg";
import four from "../assets/svg/projects/four.svg";
import one from "../assets/svg/projects/one.svg";
import seven from "../assets/svg/projects/seven.svg";
import six from "../assets/svg/projects/six.svg";
import three from "../assets/svg/projects/three.svg";
import two from "../assets/svg/projects/two.svg";
import jb from "../assets/png/jp.png";
import uberx from "../assets/png/uberx.png";
import sbs from "../assets/png/sbs.png";
import hn from "../assets/png/hn.png";
import ofs from "../assets/png/of.png";
import vtd from "../assets/png/vtd.png";
import ms from "../assets/png/ms.png";
import fs from "../assets/png/fs.png";
import hc from "../assets/png/hc.png";
import cb from "../assets/png/cb.png";
import kls from "../assets/png/cls.png";
import av from "../assets/png/av.png";
import rt from "../assets/png/rt.png";
import samin from "../assets/png/samin.png";
import sysa from "../assets/png/sysa.png";
import hlapi from "../assets/png/hlapi.png";
import chms from "../assets/png/chms.png";
import peshop from "../assets/png/p-eshop.png";
import clinic from "../assets/png/clinic.png";

export const projectsData = [
  {
    id: 1,
    projectName: "Hotel Listing API",
    projectDesc: "This is built on dotnet for hotel systems.",
    tags: ["Asp.net core", "JWT Tokens", "Swagger"],
    code: "https://github.com/haronsoft/HotelListing",
    demo: "",
    image: hlapi,
  },

  {
    id: 3,
    projectName: "Business Website",
    projectDesc:
      "This project is a template about business and corporate agency website.",
    tags: ["React", "Bootsrap", "SASS"],
    code: "",
    demo: "https://softmek-business.netlify.app/",
    image: sbs,
  },
  {
    id: 13,
    projectName: "Portal Admin",
    projectDesc: "Animated authentication system",
    tags: ["Vue", "SASS", "LESS"],
    code: "",
    demo: "",
    image: samin,
  },
  {
    id: 17,
    projectName: "Hospital Management",
    projectDesc:
      "This is a hospital information management system",
    tags: ["CodeIgniter", "Localstorage", "Tailwind", "Toastfy","Php"],
    code: "",
    demo: "",
    image: chms,
  },
  {
    id: 2,
    projectName: "Job Posting",
    projectDesc:
      "This project is a Job posting website, Clients can add job requirements and view job postings.",
    tags: ["React", "Localstorage", "Tailwind", "Toastfy"],
    code: "https://github.com/haronsoft/JobPosting",
    demo: "https://jobposting-haron.netlify.app/",
    image: jb,
  },
  {
    id: 4,
    projectName: "Hacker News",
    projectDesc:
      "This a simple project consuming Hacker News API with React and Axios",
    tags: ["React", "Axios"],
    code: "",
    demo: "https://hacker-news-algoria-api.netlify.app/",
    image: hn,
  },
  
  {
    id: 18,
    projectName: "Ecommerce Web Application",
    projectDesc:
      "This is an ecommerce web application that can be customized to clients store needs",
    tags: ["React","Laravel", "Axios"],
    code: "",
    demo: "",
    image: peshop,
  },

  {
    id: 5,
    projectName: "Organic Farm",
    projectDesc: "A website organic products that can suit farmers",
    tags: ["HTML5", "CSS3", "Bootsrap"],
    code: "",
    demo: "https://softmek-organicfarm.netlify.app/",
    image: ofs,
  },
  {
    id: 11,
    projectName: "Vehicle Advertising",
    projectDesc: "Simple website for vehicle advertisements",
    tags: ["Boostrap", "SASS", "LESS"],
    code: "",
    demo: "https://spiffy-haron-b28cd3.netlify.app/",
    image: av,
  },
  {
    id: 11,
    projectName: "Dispensary CMS",
    projectDesc: "This is a demo of the Dispensary management portal",
    tags: ["Boostrap", "SASS", "LESS","Php"],
    code: "",
    demo: "",
    image: clinic,
  },

  {
    id: 6,
    projectName: "Vue TodoList",
    projectDesc: "Picked from Front-end challenges",
    tags: ["Vuejs", "Tailwind", "Vuexy"],
    code: "https://github.com/haronsoft/QuestTodos",
    demo: "https://vue-todo-challenge.netlify.app/",
    image: vtd,
  },
  {
    id: 1,
    projectName: "UberX",
    projectDesc:
      "This is a simple dashboard build using react styled components.",
    tags: ["React", "React Router", "Styled Components"],
    code: "https://github.com/haronsoft/reactdashboard_one",
    demo: "https://react-dashboard-one.netlify.app/",
    image: uberx,
  },
  {
    id: 7,
    projectName: "Ecommerce Website",
    projectDesc: "simple multishop website",
    tags: ["React", "css3", "Bootstrap"],
    code: "",
    demo: "https://softmek-multishop.netlify.app/",
    image: ms,
  },
  {
    id: 8,
    projectName: "Finance Service",
    projectDesc: "Simple website for financial institutions",
    tags: ["Css", "React"],
    code: "",
    demo: "https://finance-softmek.netlify.app/",
    image: fs,
  },
  {
    id: 9,
    projectName: "Home Care",
    projectDesc: "Simple website for medical institutions",
    tags: ["Vue", "css"],
    code: "",
    demo: "https://homecare-softmek.netlify.app/",
    image: hc,
  },
  {
    id: 10,
    projectName: "Business Consultacy",
    projectDesc: "Simple website for business cunsultancy",
    tags: ["Boostrap", "SASS", "LESS"],
    code: "",
    demo: "https://consult-softmek.netlify.app/",
    image: cb,
  },
  {
    id: 10,
    projectName: "Cleaning Services",
    projectDesc: "Simple website for cleaning business services",
    tags: ["Boostrap", "SASS", "LESS"],
    code: "",
    demo: "https://klean-softmek.netlify.app/",
    image: kls,
  },
  {
    id: 11,
    projectName: "Vehicle Advertising",
    projectDesc: "Simple website for vehicle advertisements",
    tags: ["Boostrap", "SASS", "LESS"],
    code: "",
    demo: "https://spiffy-haron-b28cd3.netlify.app/",
    image: av,
  },
  {
    id: 12,
    projectName: "Reporting Tool",
    projectDesc: "Developer reporting tool for task Management",
    tags: ["Boostrap", "SASS", "LESS"],
    code: "",
    demo: "",
    image: rt,
  },
  {
    id: 16,
    projectName: "System Access",
    projectDesc: "Material designed System Access",
    tags: ["Boostrap", "SASS", "LESS"],
    code: "",
    demo: "",
    image: sysa,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
